import * as React from 'react';

const ProfileIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.25 21.3573L3.48898 21.1183C6.01146 18.5958 9.43267 17.1787 13 17.1787V17.1787C16.5673 17.1787 19.9885 18.5958 22.511 21.1183L22.75 21.3573"
      stroke="#ADB4C0"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <ellipse
      cx="13"
      cy="8.35721"
      rx="4.64286"
      ry="4.64286"
      stroke="#ADB4C0"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
  </svg>
);

export default ProfileIcon;
